/**
 * Created by jiachenpan on 16/11/18.
 */
import router from "@/router/router";

import Cookies from 'js-cookie';

/**
 * 获取uuid
 */
export function getUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth(key) {
  return JSON.parse(localStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}

/**
 * 清除登录信息
 */
export function clearLoginInfo(router) {
  localStorage.clear();
  Cookies.remove('appid');
  if(router){
    router.options.isAddDynamicMenuRoutes = false;
  }
}

export function getIsApp() {
  var ua = navigator.userAgent.toLowerCase();
  var isAndroid = ua.indexOf('android') > -1 || ua.indexOf('adr') > -1; //android终端

  return isAndroid;
}

export function parseTime(time, cFormat) {
  if(time === null){
    return '';
  }
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date;
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    try {
      date = new Date(time);
    }catch (e) {
      // 兼容ios系统
      date = new Date(time.replace(/-/g,"/"));
    }
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}


// 生产今天日期和一个月前的日期,
export function init_date() {
  //现在
  var time = new Date();
  var day = ('0' + time.getDate()).slice(-2);
  var month = ('0' + (time.getMonth() + 1)).slice(-2);
  var today = time.getFullYear() + '-' + month + '-' + day ;
  var firstday = time.getFullYear() + '-' + month + '-01';

  //1.一个月前 month直接减1
  var monthAgo = ('0' + (time.getMonth() )).slice(-2);
  var oneMonAgo = time.getFullYear() + '-' + monthAgo + '-' + day ;
  if(month=="01"){
    monthAgo = 12;
    var yearAgo = time.getFullYear()-1;
    oneMonAgo =yearAgo + '-' + monthAgo + '-' + day ;
  }
  //如果日期有效
  if(judgeDate(oneMonAgo)){
    return {
      today: today,
      firstday: firstday,
      oneMonAgo: oneMonAgo,
    }
  }else{
    //2.减去30天
    var ago=new Date(time.getTime() - 30*24*60*60*1000); //30天前
    var day = ('0' + ago.getDate()).slice(-2);
    var month = ('0' + (ago.getMonth() + 1)).slice(-2);
    var oneMonAgo = ago.getFullYear() + '-' + month + '-' + day ;
    return {
      today: today,
      firstday: firstday,
      oneMonAgo: oneMonAgo,
    }
  }
}

function judgeDate(date){
  const rmons = [31,29,31,30,31,30,31,31,30,31,30,31],
    pmons = [31,28,31,30,31,30,31,31,30,31,30,31];
  var year = parseInt(date.substr(0,4)),
    mon = parseInt(date.substr(5,7)),
    day = parseInt(date.substr(8,10));
  if(year % 4 == 0 && year % 100 != 0 || year % 400 == 0){
    return mon > 0 && mon <=12 && day > 0 && day <= rmons[mon-1];
  }else{
    return mon > 0 && mon <=12 && day > 0 && day <= pmons[mon-1];
  }
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}


// 方法
export function checkAuditTime(startTime, endTime){
  // 获取当前时间
  const date  = new Date()
  // 获取当前时间的年月日
  const dataStr = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()} `

   let starTimeStr = dataStr + startTime;
   let endTimeStr = dataStr + endTime;
  // 获取开始时间、结束时间、现在时间的时间戳

  // 兼容ios系统
  let startDate = new Date(starTimeStr).getTime();
  let endDate = new Date(endTimeStr).getTime();
  let nowDate = date.getTime();

  const s = startDate > endDate // 判断开始时间否大于结束时间

  if(s) [startDate, endDate] = [endDate, startDate] // 若开始时间否大于结束时间则交换值

  // 判断现在的时间是否在开始时间和结束时间之间，若s为true则结果取反
  if(nowDate > startDate && nowDate < endDate){
    return s ? false : true
  }else{
    return s ? true : false
  }
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/gi) != null) {
      len += 1
    } else {
      len += 0.5
    }
  }
  return Math.floor(len)
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
  )
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function scrollTo(element, to, duration) {
  if (duration <= 0) return
  const difference = to - element.scrollTop
  const perTick = (difference / duration) * 10
  setTimeout(() => {
    element.scrollTop = element.scrollTop + perTick
    if (element.scrollTop === to) return
    scrollTo(element, to, duration - 10)
  }, 10)
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().toDateString())
      end.setTime(start.getTime())
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一周',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    }
  }
]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

// 将十六进制颜色转为rgba,半透明度
export function colorRgba (str,n){
  //十六进制颜色值的正则表达式
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  var sColor = str.toLowerCase();
  //十六进制颜色转换为RGB格式
  if(sColor && reg.test(sColor)){
    if(sColor.length === 4){
      var sColorNew = "#";
      for(var i=1; i<4; i+=1){  //例如：#eee,#fff等
        sColorNew += sColor.slice(i,i+1).concat(sColor.slice(i,i+1));
      }
      sColor = sColorNew;
    }
    //处理六位颜色值
    var sColorChange = [];
    for(var i=1; i<7; i+=2){
      sColorChange.push(parseInt("0x"+sColor.slice(i,i+2)));
    }
    return "rgba(" + sColorChange.join(",") + ","+n+")";
  }else{
    return sColor;
  }
}

export function getIsMoreThreeMonth(date1,date2){
  let d1 = new Date(date1)*1;
  let d2 = new Date(date2)*1;
  let time = d2 - d1;
  let dayTime = 1000*60*60*24;

  let dissDay = (time / dayTime);

  return dissDay > 90;
}

export function subsctringFileName(imageUrl) {
  if(!imageUrl) return;
  if(imageUrl.includes('image')){
    return imageUrl.split('image/')[1];
  }else {
    return imageUrl.split('files/')[1];
  }
}

export function getLimitUploadImageFormat(){
  return 'image/jpg,image/jpeg,image/png,image/bmp,image/tiff';
}

export function limitImageSizeFormat(file,vm){
  const isLt10M = file.size / 1024 / 1024 < 10;
  if (!isLt10M) {
    vm.$message.error(vm.$t('上传图片大小不能超过10MB!'));
  }
  return isLt10M;
}

export function handlerChannelConfig(channelTypes,pushChannelOptions){
  for (let i = 0; i < channelTypes.length; i++) {
    switch (channelTypes[i]){
      case 1:
        pushChannelOptions.push({label: '微信公众号',value: 1});
        break;
      case 2:
        pushChannelOptions.push({label: 'Telegram',value: 2});
        break;
      case 3:
        pushChannelOptions.push({label: 'Lark应用',value: 3});
        break;
      case 4:
        pushChannelOptions.push({label: '企业微信',value: 4});
        break;
      case 5:
        pushChannelOptions.push({label: '个人微信',value: 5});
        break;
      case 6:
        pushChannelOptions.push({label: 'Lark机器人',value: 6});
        break;
      case 7:
        pushChannelOptions.push({label: '钉钉',value: 7});
        break;
      case 8:
        pushChannelOptions.push({label: 'MT4',value: 8});
        break;
      case 9:
        pushChannelOptions.push({label: 'Line',value: 9});
        break;
    }
  }
}
